/**
 * Decode a base64url-encoded string.
 * @param {string} input The base64url-encoded string.
 * @return {Uint8Array} The decoded bytes.
 */
export function decodeBase64Url(input) {
  const binary = atob(
    input.replace(/-/g, '+').replace(/_/g, '/').replace(/\s/g, ''),
  );
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

/**
 * Encode a typed array as a base64url string.
 * @param {Uint8Array} input The input.
 * @return {string} The base64url-encoded string.
 */
export function encodeBase64Url(input) {
  const chunkSize = 0x8000;

  const array = [];
  for (let i = 0; i < input.byteLength; i += chunkSize) {
    array.push(
      String.fromCharCode.apply(null, input.subarray(i, i + chunkSize)),
    );
  }
  return btoa(array.join(''))
    .replace(/=/g, '')
    .replace(/\+/g, '-')
    .replace(/\//g, '_');
}

/**
 * Generates 32 random bytes encoded as a base64url string.
 * @return {string} The encoded bytes.
 */
export function randomBytes() {
  const values = crypto.getRandomValues(new Uint8Array(32));
  return encodeBase64Url(values);
}

/**
 * Hash a string.
 * See https://github.com/bryc/code/blob/master/jshash/experimental/cyrb53.js
 * @param {string} str The string to hash.
 * @param {number} seed The seed.
 * @return {string} The hash.
 */
export function hash(str, seed = 0) {
  let h1 = 0xdeadbeef ^ seed;
  let h2 = 0x41c6ce57 ^ seed;
  for (let i = 0, ch; i < str.length; i++) {
    ch = str.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
  h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
  h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  return (4294967296 * (2097151 & h2) + (h1 >>> 0)).toString(36);
}
